/*
 * Suburb / postcode search (cart shipping band + delivery page).
 *
 * Enhances every select[data-postcodes-url] with Tom Select: the customer
 * types a suburb name (or postcode) and picks from a list that shows
 * "Suburb, STATE Postcode" so duplicate suburb names across states are
 * distinguishable. The chosen suburb/state/postcode is stashed on the
 * element's dataset, ready for the Calculate step to read.
 *
 * On the CART the Calculate button carries data-estimate-url and the pickup
 * button carries data-pickup-url; both redirect to the delivery page and
 * scroll to its band (#DeliveryBand), where the question/result renders —
 * Calculate with the picked destination (?postcode/suburb/state), pickup
 * with ?pickup=true. The estimator page's own Calculate/pickup buttons have
 * neither attribute; jc-shipping-estimator.js handles them in place.
 *
 * The dataset (assets/jc-postcodes.json — [locality, state, postcode]) is
 * ~500KB, so it is lazy-loaded on the first keystroke (preload: false),
 * never on initial render.
 */
(function () {
  function titleCase(str) {
    return str.toLowerCase().replace(/\b[a-z]/g, function (c) {
      return c.toUpperCase();
    });
  }

  // Fetch the postcode dataset once; reuse the promise for every query.
  var dataPromise = null;
  function loadPostcodes(url) {
    if (!dataPromise) {
      dataPromise = fetch(url).then(function (res) {
        if (!res.ok) throw new Error('postcodes ' + res.status);
        return res.json();
      });
    }
    return dataPromise;
  }

  function enhance(select) {
    if (select.tomselect) return;

    var url = select.dataset.postcodesUrl;

    new TomSelect(select, {
      valueField: 'value',
      labelField: 'label',
      searchField: ['suburb', 'postcode'],
      maxItems: 1,
      maxOptions: 60,
      create: false,
      preload: false,
      loadThrottle: 150,
      placeholder: 'Suburb or postcode',
      plugins: ['remove_button'],
      dropdownParent: 'body',
      dropdownClass: 'ts-dropdown cart__postcode-dropdown',
      sort: [
        { field: 'suburb', direction: 'asc' },
        { field: 'state', direction: 'asc' },
        { field: 'postcode', direction: 'asc' }
      ],
      // Prefix-match the typed query against the suburb name or postcode,
      // capped at 60 results. The dataset stores localities uppercase, so
      // compare uppercase and title-case only for display.
      load: function (query, callback) {
        var q = query.trim().toUpperCase();
        if (q.length < 2) {
          callback();
          return;
        }
        loadPostcodes(url)
          .then(function (rows) {
            var matches = [];
            for (var i = 0; i < rows.length; i++) {
              var loc = rows[i][0];
              var state = rows[i][1];
              var pc = rows[i][2];
              if (loc.indexOf(q) === 0 || pc.indexOf(q) === 0) {
                matches.push({
                  value: pc + '|' + loc + '|' + state,
                  label: titleCase(loc) + ', ' + state + ' ' + pc,
                  suburb: titleCase(loc),
                  state: state,
                  postcode: pc
                });
                if (matches.length >= 60) break;
              }
            }
            callback(matches);
          })
          .catch(function () {
            callback();
          });
      },
      render: {
        option: function (data, escape) {
          return '<div class="cart__postcode-option">' + escape(data.label) + '</div>';
        },
        item: function (data, escape) {
          return '<div>' + escape(data.label) + '</div>';
        },
        no_results: function (data, escape) {
          return '<div class="no-results">No matching suburb or postcode</div>';
        }
      },
      // Stash the chosen suburb/state/postcode on the element for the
      // Calculate step to read (and clear it when the field is cleared).
      onChange: function (value) {
        var opt = this.options[value];
        if (opt) {
          select.dataset.postcode = opt.postcode;
          select.dataset.suburb = opt.suburb;
          select.dataset.state = opt.state;
        } else {
          delete select.dataset.postcode;
          delete select.dataset.suburb;
          delete select.dataset.state;
        }
      }
    });
  }

  // The delivery page band's id — both cart redirects append it as a hash
  // so the page scrolls to the band, with the question/result just below.
  var BAND_ANCHOR = '#DeliveryBand';

  // Cart page only: Calculate redirects to the delivery page with the
  // picked destination; the pickup CTA redirects with ?pickup=true. Buttons
  // without the data-*-url attributes (the estimator page's own Calculate /
  // pickup) are left alone.
  function wireCartActions() {
    var calc = document.querySelector('.cart__shipping-info-button[data-estimate-url]');
    if (calc && !calc.dataset.estimateWired) {
      calc.dataset.estimateWired = 'true';
      calc.addEventListener('click', function () {
        var select = document.getElementById('CartPostcode');
        var d = (select && select.dataset) || {};
        if (!d.postcode) {
          // Nothing picked yet — open the picker as the nudge.
          if (select && select.tomselect) select.tomselect.open();
          else if (select) select.focus();
          return;
        }
        window.location.href =
          calc.getAttribute('data-estimate-url') +
          '?postcode=' + encodeURIComponent(d.postcode) +
          '&suburb=' + encodeURIComponent(d.suburb || '') +
          '&state=' + encodeURIComponent(d.state || '') +
          BAND_ANCHOR;
      });
    }

    var pickup = document.querySelector('.jc-estimator__pickup-cta[data-pickup-url]');
    if (pickup && !pickup.dataset.pickupWired) {
      pickup.dataset.pickupWired = 'true';
      pickup.addEventListener('click', function () {
        window.location.href = pickup.getAttribute('data-pickup-url') + '?pickup=true' + BAND_ANCHOR;
      });
    }
  }

  function init() {
    if (typeof TomSelect === 'undefined') return;
    var selects = document.querySelectorAll('select[data-postcodes-url]');
    for (var i = 0; i < selects.length; i++) enhance(selects[i]);
    wireCartActions();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
